// INDEXES MULTIPLE ARBITRABLE TRANSACTION
export const BLOCKCHAIN_NON_TECHNICAL_MULTIPLE_ARBITRABLE_INDEX = 0;
export const GENERAL_MULTIPLE_ARBITRABLE_INDEX = 1;

export const SEPOLIA_MULTIPLE_ARBITRABLE_TRANSACTION_ADDRESSES = [
  "0x338f1A474e0FB0ae9E913cFA3d7c6Aa19b92015B", // Blockchain Non-Technical
  "0x9262c1c7810571B189db83F945e7e8b67abcE1c8", // General Court
];

export const SEPOLIA_MULTIPLE_ARBITRABLE_TOKEN_TRANSACTION_ADDRESSES = [
  "0x58fc7e398B4a1886695ab2C7fE7c31F49393a8c5", // Blockchain Non-Technical
  "0x6048002b6E93A4A5d93E902F2427D7472790aC97", // General Court
];

export const MAINNET_MULTIPLE_ARBITRABLE_TRANSACTION_ADDRESSES = [
  "0xE2Dd8CCe2c33a04215074ADb4B5820B765d8Ed9D", // Blockchain Non-Technical
  "0x0d67440946949fe293b45c52efd8a9b3d51e2522", // General Court
];

export const MAINNET_MULTIPLE_ARBITRABLE_TOKEN_TRANSACTION_ADDRESSES = [
  "0xC25a0b9681ABF6F090AEd71a8c08fB564b41dab6", // Blockchain Non-Technical
  "0xBCf0d1AD453728F75e9cFD4358ED187598A45e6c", // General Court
];

// T2CR
export const SEPOLIA_T2CR_ADDRESS =
  "0x899B8c6fE36cbFca1e6398e33B93707fF45d6e30";
export const MAINNET_T2CR_ADDRESS =
  "0xebcf3bca271b26ae4b162ba560e243055af0e679";

// ERC20
export const SEPOLIA_ERC20_BADGE_ADDRESS =
  "0xa19f50646Ac4eA8181D41ad2c24CD860596e44e1";
export const MAINNET_ERC20_BADGE_ADDRESS =
  "0xcb4aae35333193232421e86cd2e9b6c91f3b125f";

// STABLECOIN
export const SEPOLIA_STABLECOIN_BADGE_ADDRESS =
  "0x297B3Ff79EC4fe3bfD73C0E5d3eb09244914c21f";
export const MAINNET_STABLECOIN_BADGE_ADDRESS =
  "0xbc65204861f5776564fc3f61c04ec6ea8bea13be";

// TOKENSVIEW
export const SEPOLIA_TOKENS_VIEW_ADDRESS =
  "0x6f9A63F3613B8dd002bd59073B23e03648eF7a0e";
export const MAINNET_TOKENS_VIEW_ADDRESS =
  "0xf9b9b5440340123b21bff1ddafe1ad6feb9d6e7f";
